import { ComponentProps } from 'react';

import { OmitStrict } from '../../../types';
import Icon from '../../Icon';

type Props = OmitStrict<ComponentProps<typeof Icon>, 'size'>;

export const InputIcon: React.FC<Props> = props => <Icon size="m" {...props} />;
